(() => {
  const initialize = () => {
    const header = document.querySelector('[data-dm-collection-header]');
    const compact = header?.querySelector('.dm-parts-mobile');
    const description = header?.querySelector('[data-dm-original-description]');
    const more = document.querySelector('[data-dm-parts-more]');
    const content = more?.querySelector('[data-dm-parts-more-content]');
    const products = document.getElementById('dm-collection-products');
    if (!compact || !description || !content || !products) return;
    if (header.dataset.dmInitialized) return;
    const authored = description.querySelector('.dm,[class^="dms-"]') || Array.from(description.children).find(node => node.querySelector('h1'));
    if (!authored) { compact.remove(); return; }
    header.dataset.dmInitialized = 'true';
    const wideTemplate = header.querySelector('[data-dm-wide-links]');
    const originalHero = description.querySelector('.hero,.dms-hero,.dms-rh-hero,.h') || authored;
    if (wideTemplate && originalHero && !description.querySelector('.dm-parts-wide-links')) originalHero.after(wideTemplate.content.cloneNode(true));
    const featureDestinations = {
      'Brake Pads':'/collections/performance-street-brake-pads',
      'Performance Rotors':'/collections/brake-rotors-drilled-slotted-near-you',
      'Big Brake Kits':'/collections/big-brake-kits-near-you',
      'Cold Air Intakes':'/collections/cold-air-intake-systems',
      'Short Ram':'/collections/short-ram-intake-systems',
      'Airflow':'/collections/air-intake-components-canada',
      'Vehicle Specific':'/pages/shop-by-vehicle'
    };
    description.querySelectorAll('.featurebar>div').forEach(item => {
      const label = item.querySelector('strong')?.textContent.trim();
      const destination = featureDestinations[label];
      if (!destination || item.querySelector('a')) return;
      const link = document.createElement('a');
      link.className = 'dm-parts-feature-link';
      link.href = destination;
      while (item.firstChild) link.append(item.firstChild);
      item.append(link);
    });
    const intro = compact.querySelector('.dm-parts-copy p');
    if (!intro.textContent.trim()) {
      const paragraph = originalHero.querySelector('p') || authored.querySelector('p');
      const text = paragraph?.textContent.replace(/\s+/g,' ').trim() || '';
      const sentence = text.match(/^.*?[.!?](?:\s|$)/)?.[0].trim() || text;
      intro.textContent = sentence.length > 180 ? sentence.slice(0,177).replace(/\s+\S*$/,'') + '…' : sentence;
    }
    const image = compact.querySelector('.dm-parts-image');
    if (!image.getAttribute('src')) {
      const source = originalHero.querySelector('img') || authored.querySelector('img');
      const src = source?.getAttribute('src') || source?.getAttribute('data-src');
      if (src) { image.src = src; image.hidden = false; }
    }
    compact.classList.toggle('dm-parts-no-image', image.hidden);
    const nav = compact.querySelector('.dm-parts-categories nav');
    if (!nav.children.length) {
      const seen = new Set();
      description.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.getAttribute('href'), location.href);
        const label = link.textContent.replace(/\s+/g,' ').trim();
        if (url.origin !== location.origin || !url.pathname.startsWith('/collections/') || url.pathname === location.pathname || !label || seen.has(url.pathname)) return;
        seen.add(url.pathname);
        const item = document.createElement('a');
        item.href = url.pathname + url.search + url.hash;
        item.textContent = label;
        nav.append(item);
      });
    }
    if (location.pathname === '/collections/cts-turbo-canada') {
      const ctsParts = {
        'Turbocharger Upgrades':'/collections/turbo-upgrades-canada',
        'Cold Air Intake Systems':'/collections/cold-air-intake-systems',
        'Turbo Inlets & Outlet Pipes':'/collections/air-intake-components-canada',
        'Intercooler & Charge-Air Upgrades':'/collections/intercooler-upgrade-canada',
        'Downpipes & Exhaust Components':'/collections/turbo-downpipes'
      };
      authored.querySelectorAll('.opts .opt').forEach(item => {
        const label = item.textContent.trim();
        const path = ctsParts[label];
        if (!path) return;
        const href = path + '?vendor/CTS%20Turbo';
        if (!item.querySelector('a')) {
          const link = document.createElement('a');
          link.href = href; link.textContent = label; item.replaceChildren(link);
        }
        if (!Array.from(nav.children).some(link => link.textContent === label)) {
          const link = document.createElement('a');
          link.href = href; link.textContent = label; nav.append(link);
        }
      });
    }
    if (!nav.children.length) {
      const seen = new Set();
      document.querySelectorAll('.menu-lv-1 > p > a[href^="/collections/"]').forEach(link => {
        const href = link.getAttribute('href');
        if (href === location.pathname || seen.has(href)) return;
        seen.add(href);
        const item = document.createElement('a');
        item.href = href; item.textContent = link.textContent.trim(); nav.append(item);
      });
    }
    compact.querySelector('.dm-parts-categories').hidden = !nav.children.length;
    compact.querySelector('.dm-parts-categories').open = window.matchMedia('(min-width:768px)').matches;
    content.append(description);
    header.classList.add('dm-parts-ready');
    more.parentElement.classList.add('dm-parts-ready');
    const jump = event => {
      event.preventDefault();
      products.scrollIntoView({behavior:'auto',block:'start'});
      products.focus({preventScroll:true});
    };
    compact.querySelector('.dm-parts-shop').addEventListener('click', jump);
    description.querySelector('.dm-parts-wide-shop')?.addEventListener('click', jump);
    description.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.getAttribute('href'), location.href);
      const isCollectionLink = url.pathname === location.pathname && url.pathname.startsWith('/collections/');
      const isHeroShop = originalHero?.contains(link) && /shop|browse/i.test(link.textContent);
      if (isCollectionLink || isHeroShop) {
        link.setAttribute('href','#dm-collection-products');
        if (!link.classList.contains('dm-parts-wide-shop')) link.addEventListener('click', jump);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      initialize();
    });
  }).observe(document.body,{childList:true,subtree:true});
})();
